import {React, useEffect} from "react";
import HeroHeader from "./HeroHeader";
import ContactCTA from "./ContactCTA";
import ButtonLink from "./ButtonLink";
import { Helmet } from "react-helmet";

import HeaderMockup from "../img/endocarditis_mockup.png";
import FinalSpread from "../img/IE_final.jpg";
import QR from "../img/pattern-qr-code.png";
import ModelVideo from "../video/IE_model.mp4";
import Wireframes from "../img/IE-AR_wireframes.png";
import Prototype from "../img/IE_prototype.gif";
import TissueCubes from "../img/Chung_Eric_Tissue cubes.jpg";
import TissueLandscape from "../img/Chung_Eric_TissueLandscape.jpg";



function Endocarditis() {

  // useEffect(() => {
  //   document.title = "ETCHNG | Engaging readers on infective endocarditis using WebAR";  
  
  // }, []);      
  return (
    <>
    <Helmet>
        <title>ETCHNG | Engaging readers on infective endocarditis using WebAR</title>
        <meta name="description" content="Death zone scrolling data visualization"/> 
        <meta name="keywords" content=" Eric Chung, medical illustrator, UI/UX designer, web developer, cardiac, endocarditis, WebAR, A-Frame, Three.JS, Blender, Photoshop, Illustrator, HTML/CSS/JS"
        />
    </Helmet>
      <HeroHeader
        hero_img={HeaderMockup}
        type="Print spread —"
        name="Engaging readers on infective endocarditis using WebAR"
      />

      <div className="wrapper">
        <div className="wrapper__inner">
          <div className="work">
            <div className="work__info twoColumn">
              <div className="work__info__basic">
              <div className='work__info__basic__item'> <h5>Date</h5>
                  <p>Nov 2020</p> </div>
                  <div className='work__info__basic__item'>    <h5>Role</h5>
                  <p>Illustrator, UI/UX designer, web developer</p></div>
                  <div className='work__info__basic__item'> <h5>Tools</h5>
                  <p>Blender, Photoshop, Illustrator, HTML/CSS/JS (A-Frame, Three.JS)</p></div>
              </div>
            </div>

            <div className="work__info twoColumn">
              <h4>INTRODUCTION</h4>
              <p> Infective endocarditis is a microbial infection of the endocardium, the inner lining of the heart. The
              cardiac valves are typically the primary target, particularly the mitral and aortic valves.
</p>

              <div className="btn__wrap">
                <a href="https://etchng.github.io/IE-AR/" target="_blank">
                  <ButtonLink> View Demo</ButtonLink>
                </a>
              </div>
            </div>

            
          </div>
          <div className="work">
              <div className="work__info twoColumn">
                <h4>CHALLENGE</h4>
              </div>
              <div className="work__info twoColumn">
              <p>Infective endocarditis is a relatively uncommon pathology, occuring primarily in individuals with
              pre-existing heart conditions. As its particular mechanism of disease propogates from the histological
              level to the structural-mechancal level, its effects can be difficult to grasp conceptually.</p>
            <p>
              This multimedia experience was framed as a science engagement tool, being intended for a two page print
              spread. It is meant to provide a low-barrier to entry means of capturing the attention of an educated lay
              audience, while delivering key facts about a relatively uncommon disease.

            </p>

              </div>
            </div>

            <div className="work">
          <div className="work__info twoColumn">
            <h4>IDEATION</h4>


          </div>

        </div>
        <div className="work">

<div className="work__info twoColumn">

  <img src={TissueLandscape} loading="lazy"
    alt="Greyscale illustration study of the trabeculae."></img>


</div>
<div className="work__info twoColumn">
  <img src={TissueCubes} loading="lazy"
    alt="Greyscale illustration study of tissue cubes."></img>


</div>

</div>
<div className="work">

<div className="work__info narrowColumn">

  <p>
    I quickly iterated several wireframe designs of the potential interface, and A/B tested them with users
    for feedback. I also began coding out a low-fidelity prototype with placeholder assets to test
    functionality.
  </p>

  <img src={Prototype} loading="lazy" alt="Coded prototype"></img>

</div>
<div className="work__info wideColumn">
  <img src={Wireframes} loading="lazy"
    alt="Potential user interface concepts for the web AR application."></img>
</div>




</div>
<div className="work">
<div className="work__info narrowColumn">
  <h4>DESIGN</h4>

  <p>I then refined my initial 3D model of the left ventricle based on the imaging data, then
    rigged and animated it. Valves were kept as seperate meshes to allow for visibility
    toggling, and swapping structures.</p>
</div>
<div className="work__info wideColumn">


  <video loop autoPlay width="540" height="540">
    <source src={ModelVideo} loading="lazy" type="video/mp4"/>
    Your browser does not support the video tag.
  </video>


</div>





</div>

<div className="work">
<div className="work__info twoColumn">

  <img src={QR} loading="lazy"
    alt="QR code that links to the web AR app, and also functions as the tracker."></img>

</div>
<div className="work__info twoColumn">
  <p>As this is intended to be a casual engagement tool, I felt that it was important to maintain
    a low barrier to entry for users. Ease of web access was prioritized instead of a
    downloadable app, and I thus opted to code it with the A-Frame library over a game engine.</p>
  <p>While I had originally conceived that it would use image-based tracking, with the overall
    spread as the marker, I ultimately used the QR code used for the link for the web app as the
    marker, as it provided a more consistent experience.</p>
</div>




</div>
<div className="work">

<div className="work__info narrowColumn">
  <p>
    The final deliverables include an illustrated two-page spread, as well as an accompanying WebAR app that can be accssed by scanning the QR code in the corner. This is intended to help the user better understand
    the three-dimensional and biomechanical implications of the disease.

  </p>


  <p>The final AR app allows the for the following functions:
  </p>

  <ul>
    <li>Playing and pausing the animation</li>
    <li>Pinching and zooming, and drag and rotating</li>
    <li>Toggling visibility of structures</li>
    <li>Switching between the normal and pathological model</li>
    <li>Isolating the mitral valve</li>
    <li>Toggling blood flow visibility</li>
    <li>Toggling label visibility</li>
  </ul>
</div>
  <div className="work__info wideColumn">
    <iframe className="youtube" height="500" src="https://www.youtube.com/embed/Y20Kae7SoW8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>





</div>

<div className="work">
<div className="work__info singleColumn">
<img src={FinalSpread} loading = "lazy" alt="Final illustrated spread."></img>
</div>
</div>
</div>

        <ContactCTA />
      </div>
    </>
  );
}

export default Endocarditis;
